let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gh5Lp")).then(() => parcelRequire('5RMdw'));